// noinspection DuplicatedCode

import {Component, OnInit} from '@angular/core';
import {AuthenticationService} from "../../../services/apiServices/security/authentication.service";
import {FoldDetailService} from "../../../services/apiServices/business/fold-detail.service";
import {Unsubscribable} from "../../mixin/unsubscribable.component";
import {User} from "../../../model/user";
import {ActionLogging} from "../../../model/action-logging";
import {ColumnDatatable} from "../../../model/column-datatable";
import {BehaviorSubject} from "rxjs";
import {IndexActionLoggingEnums} from "../../../enums/action-logging.enums";
import {ActionUserFilter} from "../../../model/action-user-filter";
import {DetailsActionLogging} from "../../../model/details-action-logging";
import {CommonService} from "../../../services/apiServices/business/common.service";
import {TranslateService} from "@ngx-translate/core";
import {FileSaverService} from "ngx-filesaver";
import {CustomDate} from "../../../model/custom-date";
import {formatDate} from "@angular/common";


@Component({
  selector: 'app-action-logging',
  templateUrl: './action-logging.component.html',
  styleUrls: ['./action-logging.component.scss']
})
export class ActionLoggingComponent extends Unsubscribable(class {}) implements OnInit{

  public trackingDetailsUserList: DetailsActionLogging[]
  public columnsUser: ColumnDatatable[]
  public columnsDetailsUser: ColumnDatatable[]
  public sortField: string;
  public defaultSortOrder= 1;
  public activeTabIndex: number = 0;
  public dateBegging: Date = new Date(new Date().setDate(1));
  public dateEnd: Date = new Date();
  public filterUserList: ActionUserFilter;
  public yearRange=[new Date('2012-01-01'), new Date()];

  private currentUser: User;
  private activeTabViewSubject: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  private successDownloadTitle: string;
  private successDownloadMessage: string;
  protected selectedAction:string = "";

  protected actionOptions: { label: string, value: string }[] = [];

  protected allActionsList: string[];

  constructor(
    private authService: AuthenticationService,
    private foldDetailService: FoldDetailService,
    private commonService: CommonService,
    private translateService: TranslateService,
    private fileSaverService: FileSaverService
  ) {
    super();
  }

  ngOnInit(): void {
    this.currentUser = this.authService.getCurrentUser();

    if(this.currentUser) {
      this.filterUserList  = new ActionUserFilter(this.currentUser.idCustomer);

      this.allActionsList =[
        'ALL',
        'LOGIN',
        'QUERY',
        'DOWNLOAD',
        'UNKNOWN',
        'EXPORT',
        'DEPOSIT'
      ];
      for (let option of this.allActionsList){
        this.actionOptions.push({label:this.translateFieldValue("action", option), value:option });
      }

    }
    this.buildColumnDataTable();
    this.translateTitle();
  }

  public filterListUser(): void {
    this.dateBegging.setHours(0, 0, 0, 0);
    this.dateEnd.setHours(23, 59, 59, 999);
    this.filterUserList.beginningDate = this.filterUserList.formatDate(this.dateBegging);
    this.filterUserList.endDate = this.filterUserList.formatDate(this.dateEnd);
    this.filterUserList.action = this.selectedAction;

    this.foldDetailService.getTrackingDetailsUserList(this.filterUserList)
      .pipe(this.takeUntilDestroyed())
      .subscribe(objTrackingDetailsUserList => {
        this.trackingDetailsUserList = objTrackingDetailsUserList.listObjTrackingDetailsUser;
      })
  }

  public handleTabChange(event: any): void {
    this.activeTabViewSubject.next(event.index);
  }

  public exportToCSV(columns: ColumnDatatable[], data: any): void {
    const headerKeys = columns.map(col => col.header);
    this.translateService.get(headerKeys)
      .pipe(this.takeUntilDestroyed())
      .subscribe(translatedHeaders => {
        const fields = columns.map(col => col.field);
        const csvData = this.convertToCSV(translatedHeaders, fields, data);
        const fileName = `exported_action_logging_${CustomDate.getFormatedToday()}.csv`;

        const blob = new Blob(['\uFEFF' + csvData], { type: 'text/csv;charset=utf-8' });

        this.fileSaverService.save(blob, fileName);
        this.commonService.addToast({
          life: 3000,
          severity: 'success',
          summary: this.successDownloadTitle,
          detail: this.successDownloadMessage
        });
    });

  }

  private convertToCSV(translatedHeaders: any, fields: string[], data: any[]): string {
    const headers = fields.map(field => translatedHeaders[`TRACKING_USER.FIELD_HEADER.${field.toUpperCase()}`]);
    const rows = data.map(row => {
      return fields.map(field => {
        let value = row[field];

        if ((field === 'trtDateTime' || field === 'actionDateTime') && typeof value === 'number') {
          value = formatDate(new Date(value), 'dd/MM/yyyy HH:mm:ss', 'en-EN');
        }

        return this.translateFieldValue(field, value);
      }).join(';');
    });

    return [headers.join(';'), ...rows].join('\n');
  }

  private translateFieldValue(field: string, value: any): string {
    const translationKeyMap = {
      docState: {
        'RESTORE': 'TRACKING_USER.ACTION.RESTORE',
        'DISMISSED': 'TRACKING_USER.ACTION.DISMISSED',
        'NEWRUN': 'TRACKING_USER.ACTION.NEWRUN',
        'DONE': 'TRACKING_USER.ACTION.DONE'
      },
      action: {
        'ALL':'TRACKING_USER.ACTION.ALL',
        'LOGIN': 'TRACKING_USER.ACTION.LOGIN',
        'QUERY': 'TRACKING_USER.ACTION.QUERY',
        'DOWNLOAD': 'TRACKING_USER.ACTION.DOWNLOAD',
        'UNKNOWN': 'TRACKING_USER.ACTION.UNKNOWN',
        'EXPORT': 'TRACKING_USER.ACTION.EXPORT',
        'DEPOSIT': 'TRACKING_USER.ACTION.DEPOSIT'
      }
    };

    if (translationKeyMap[field] && translationKeyMap[field][value]) {

      const translationKey = translationKeyMap[field][value];
      let translatedValue = '';

      this.translateService.get(translationKey).subscribe(translated => translatedValue = translated);
      return translatedValue;
    }
    return value;

  }

  private buildColumnDataTable(): void {
    this.columnsUser = [
      {field: 'userID', header: 'TRACKING_USER.FIELD_HEADER.USERID', width: 100},
      {field: 'action', header: 'TRACKING_USER.FIELD_HEADER.ACTION', width: 100},
      {field: 'actionDateTime', header: 'TRACKING_USER.FIELD_HEADER.ACTIONDATETIME', width: 120},
      {field: 'remoteAddress', header: 'TRACKING_USER.FIELD_HEADER.REMOTEADDRESS'},
    ];

    this.columnsDetailsUser = [
      {field: 'userID', header: 'TRACKING_USER.FIELD_HEADER.USERID'},
      {field: 'action', header: 'TRACKING_USER.FIELD_HEADER.ACTION', width: 100},
      {field: 'actionDateTime', header: 'TRACKING_USER.FIELD_HEADER.TRTDATETIME', width: 120},
      {field: 'serialSent', header: 'TRACKING_USER.FIELD_HEADER.SERIALSENT', width: 100},
      {field: 'docState', header: 'TRACKING_USER.FIELD_HEADER.DOCSTATE'},
      {field: 'operName', header: 'TRACKING_USER.FIELD_HEADER.OPERNAME', width: 100},
    ];
  }

  private translateTitle(): void {
    this.translateService.get('TOASTER.SUCCESS_MESSAGE_TITLE').subscribe((title: string) => {
      this.successDownloadTitle = title;
    });
    this.translateService.get('TOASTER.SUCCESS_DOWNLOAD_OK').subscribe((title: string) => {
      this.successDownloadMessage = title;
    });
  }
}
